<template>
  <div>
    <!-- <div class="grid grid-cols-3 gap-4 mt-6">
      <el-card class="elcard-p0px rounded-10px">
        <div class="flex items-center py-2">
          <div
            class="bg-f4f5f6 text-center bor-baju border-none text-8f8f8f p-2 w-1/3"
          >
            <p class="fsize10 font-normal text-8f8f8f">October</p>
            <h1 class="font-bold text-primary mb-0 text-2xl">24</h1>
            <p class="fsize10 font-normal text-8f8f8f">Monday</p>
          </div>
          <div class="items-center w-8/12 pl-2">
            <div>
              <small class="fsize10 font-semibold col-4f"
                >Festival Holiday</small
              >
              <h1 class="font-semibold text-dark mb-0 fsize14">
                World Health Day
              </h1>
              <small class="fsize10 font-medium text-8f8f8f">Industry</small>
            </div>
          </div>
        </div>
        <div>
          <div
            class="p-4"
            :style="{
              background: brandProfile.primaryColor
                ? brandProfile.primaryColor
                : '#f4f5f6',
            }"
          >
            <div class="flex items-center mb-2">
              <img :src="getImage" class="w-12 rounded-md" alt="logo" />
            </div>
            <h2
              class="font-semibold flex justify-between items-center text-white fsize16"
            >
              Primary card title
              <feather-icon
                @click="updatePopupDetails(item)"
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              />
            </h2>
            <p class="mt-2 mb-4 font-medium fsize12 text-white lineclamp-2">
              Create a custom video greeting to represent your brand.
            </p>

            <img
              :src="
                layout.img
                  ? layout.img
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/imageLayouts/1.png'
              "
              alt="image"
              class="w-full h-130px"
            />
          </div>

          <div class="grid grid-cols-2 p-4 justify-end gap-2">
            <vs-button type="border" color="primary" class="sm-button w-full"
              >Edit</vs-button
            >

            <vs-button color="warning" class="sm-button w-full"
              >Design Post</vs-button
            >
          </div>
        </div>
      </el-card>
    </div> -->
    <div class="grid grid-cols-2 gap-4 mt-6">
      <el-card
        class="elcard-p0px rounded-10px"
        v-for="(item, index) in events"
        :key="'index-' + index"
      >
        <div class="flex items-center py-2">
          <div
            class="bg-f4f5f6 text-center bor-baju border-none text-8f8f8f p-2 w-1/6"
          >
            <p class="fsize10 font-normal text-8f8f8f">
              {{ month[new Date(item.eventDate).getMonth()] }}
            </p>
            <h1 class="font-bold text-primary mb-0 text-2xl">
              {{ new Date(item.eventDate).getDate() }}
            </h1>
            <p class="fsize10 font-normal text-8f8f8f">
              {{ day[new Date(item.eventDate).getDay()] }}
            </p>
          </div>
          <div class="items-center w-5/6 px-2">
            <div>
              <small class="fsize10 font-semibold col-4f"
                >Festival Holiday</small
              >
              <h1 class="font-semibold text-dark mb-0 fsize14 lineclamp-2">
                {{ item.eventTitle }}
              </h1>
              <small class="fsize10 font-medium text-8f8f8f">Industry</small>
            </div>
          </div>
        </div>

        <div :class="Posts[index] ? `img_wrap_LinkedIn` : `img_wrap`">
          <div v-if="Posts[index]">
            <!-- <img :src="Posts[index]" alt="image" class="w-full object-cover" /> -->
            <canvas
              :style="{ pointerEvents: `none` }"
              :id="`my-previewcanvaslink` + index"
            ></canvas>
          </div>
          <div v-else class="flex w-full">
            <div
              class="p-4 w-full"
              :style="{
                background: item.isLayout
                  ? brandProfile.primaryColor
                  : '#f4f5f6',
              }"
            >
              <div>
                <div class="flex items-center mb-2">
                  <img :src="getImage" class="w-12 rounded-md" alt="logo" />
                </div>
                <div class="flex justify-between items-center">
                  <h2
                    :style="{
                      color: item.isLayout ? '#fff' : '#000',
                    }"
                    class="font-semibold fsize16 lineclamp-1"
                  >
                    {{ item.subtitle }}
                  </h2>
                  <!-- <feather-icon
                    @click="updatePopupDetails(item)"
                    icon="EditIcon"
                    svgClasses="w-4 h-4"
                    class="cursor-pointer"
                  /> -->
                </div>
              </div>
              <p
                :style="{
                  color: item.isLayout ? '#fff' : '#000',
                }"
                class="mt-2 mb-2 font-medium fsize12 lineclamp-1"
              >
                {{ item.caption }}
              </p>

              <!-- <div class="relative cursor-pointer">
            <img
              :src="
                layoutImageSource
                  ? layoutImageSource
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/projects/branding/imageLayouts/1.png/assets/hello.png'
              "
              class="rounded-full w-16 h-16"
            />

            <div class="absolute bottom-0 right-0">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/projects/branding/imageLayouts/1.png/assets/up.png"
                alt="image"
                class=""
              />
            </div>
            <input
              type="file"
              ref="fileInput1"
              @change="uploadFile"
              class="choosefilelogo"
            />
          </div> -->
              <svg
                viewBox="0 0 1080 1080"
                v-html="svg.svg"
                class="w-full object-cover rounded-4px h-500px cursor-pointer"
              ></svg>
              <!-- <img
                :src="
                  layout.img
                    ? layout.img
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/imageLayouts/1.png'
                "
                alt="image"
                class="w-full h-195px object-cover"
              /> -->
            </div>
          </div>
        </div>
        <div class="flex p-4 w-full gap-2" v-if="Posts[index]">
          <div class="grid grid-cols-2 w-full justify-center gap-2">
            <vs-button
              type="border"
              @click="updatePopupDetails(index)"
              class="sm-button w-full"
              >Edit</vs-button
            >

            <vs-button
              color="success"
              class="bg-success sm-button w-full"
              @click="shareImage(Posts[index])"
              >Download</vs-button
            >
          </div>
        </div>
        <div v-else class="p-5">
          <vs-button
            type="border"
            @click="updatePopupDetails(index)"
            class="sm-button w-full"
            >Create Post</vs-button
          >
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import { fabric } from "fabric";
import { fontMachine } from "./fontMachine.js";
export default {
  props: {
    layout: {
      type: String,
      default: "",
    },
    events: {
      type: Array,
      default: [],
    },
    Posts: {
      type: Array,
      default: [],
    },
    svg: {
      type: Object,
    },
    PreviewUpdate: {
      type: Boolean,
    },
    // layout: {
    //   img: { type: String },
    //   id: { type: String },
    //   default: "",
    // },
  },
  data() {
    return {
      eventsCard: [],
      url: this.$imageURL,
      month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      day: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      isShowContentEdit: false,
      description: "",
      title: "",

      layoutImageSource: "",
      isShowImage: "",
      canvas: "",
      Coords_image: [null, null],
      rotation_image: [0, 0],
      Coords_text: [null, null, null, null],
      ParagraphFont: "",
      primaryFont: "",
      fetchLayout: false,
      ColoredLayout: "",
      Layoutid: "",
      PreviousLayoutIds: [""],
      NewLayoutIds: [],
      svgStrings: [],
      isSvgupdating: false,
    };
  },

  computed: {
    ...mapState("brandProfile", ["brandProfile", "layoutSelected"]),
    getImage() {
      return this.brandProfile.primaryLogo
        ? `${this.$imageURL}/${this.brandProfile.primaryLogo}`
        : "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/icecream.png";
    },
  },

  watch: {
    async PreviewUpdate() {
      console.log("ChangedPlatform");
      this.fetchLayout = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        console.log(this.Posts, "Posts");
        this.NewLayoutIds = [];
        this.Posts.map((ele) => {
          this.NewLayoutIds.push(ele.id);
        });
        console.log(this.NewLayoutIds, "Posts");
        await this.initalizePreview();
      }, 1000);
    },

    layoutSelected() {
      this.setLayout();
    },
    async ParagraphFont(newValue) {
      //if (this.isCanvasSupplied) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (newValue === this.ParagraphFont) {
          try {
            await fontMachine([this.ParagraphFont]);
          } catch (error) {
            console.log("error");
          }
          await this.initalizePreview();
        }
      }, 1000);
      // }
    },
    async primaryFont(newValue) {
      //  if (this.isCanvasSupplied) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (newValue === this.primaryFont) {
          try {
            await fontMachine([this.primaryFont]);
          } catch (error) {
            console.log("error");
          }

          await this.initalizePreview();
        }
      }, 1000);
      // }
    },
  },
  async mounted() {
    if (this.Posts) {
      this.timeout = setTimeout(async () => {
        console.log(this.Posts, "Posts");
        this.fetchLayout = true;
        await this.initalizePreview();
      }, 1000);
      clearTimeout(this.timeout);
    }

    // await this.setLayout();

    // await this.getBrandingImage();
  },
  methods: {
    arraysAreEqual(arr1, arr2) {
      return JSON.stringify(arr1) === JSON.stringify(arr2);
    },
    async fontLoad() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        try {
          await fontMachine([this.ParagraphFont]);
          await fontMachine([this.primaryFont]);
        } catch (error) {
          console.log(error);
        }

        await this.initalizePreview();
      }, 1000);
    },
    convertXandy(ow, oh, x, y, cw, ch) {
      return [(x / ow) * cw, (y / oh) * ch];
    },
    converter(image, text, ow, oh, cw, ch) {
      let imageCoors = [];
      let textCoors = [];
      for (let i = 0; i <= image.length - 1; i++) {
        imageCoors.push(
          this.convertXandy(ow, oh, image[i]["x"], image[i]["y"], cw, ch)
        );
      }
      for (let i = 0; i <= text.length - 1; i++) {
        textCoors.push(
          this.convertXandy(ow, oh, text[i]["x"], text[i]["y"], cw, ch)
        );
      }
      return [imageCoors, textCoors];
    },
    async initalizePreview() {
      window.addEventListener("resize", this.initalizePreview);
      for (let i = 0; i <= this.Posts.length - 1; i++) {
        if (this.Posts[i]) {
          let zoomWidth = 270;
          let zoomHeight = 188;
          let calibratedScreensize = [1920, 963];
          let canvasWidth = 1200;
          let canvasHeight = 628;
          let originalWidth = 1200;
          let originalHeight = 628;
          let canvas;
          let vw = window.innerWidth;
          let initialwidth = zoomWidth;
          console.log(window.innerWidth, window.innerHeight, "dimension");

          // console.log(Math.min(vw * (10 / 100), 270), "vw");
          // zoomWidth = Math.min(vw * (20 / 100), 270);
          // zoomHeight = Math.min(vw * (20 / 100), 270);

          //M
          console.log(this.Posts[i]);
          const post = this.Posts[i];

          let primaryColor;
          let secondaryColor;
          let svgString;
          let image_url;
          let logo_url;
          let text1Color;
          let text2Color;

          let text3Color;
          let text4Color;
          if (post.brandName == "base-admin") {
            primaryColor = this.brandProfile.primaryColor;
            secondaryColor = this.brandProfile.secondaryColor;
            console.log(this.brandProfile.primaryLogo, "logo");
            logo_url = this.brandProfile.primaryLogo;
            image_url = post.image[1];
          } else {
            primaryColor = post.primary;
            secondaryColor = post.secondary;
            logo_url = post.image[0];
            image_url = post.image[1];
          }
          if (post.textColors.length != 0) {
            text1Color = post.textColors[0];
            text2Color = post.textColors[1];

            text3Color = post.textColors[2];
            text4Color = post.textColors[3];
          } else {
            text1Color = post.fontColors[0];
            text2Color = post.fontColors[1];

            text3Color = post.fontColors[2];
            text4Color = post.fontColors[3];
          }
          //  primary: this.brandProfile.primaryColor,
          //     secondary: this.brandProfile.secondaryColor,
          console.log(
            this.arraysAreEqual(this.PreviousLayoutIds, this.NewLayoutIds),
            "Posts"
          );
          console.log(this.PreviousLayoutIds, this.NewLayoutIds, "Posts");

          if (!this.arraysAreEqual(this.PreviousLayoutIds, this.NewLayoutIds)) {
            if (!this.isSvgupdating) {
              this.svgStrings = [];
              this.isSvgupdating = true;
            }
            let { data } = await axios
              .post(
                process.env.VUE_APP_SVG_DATAENTRY + "/Templates" + "/Readone",
                {
                  id: post.id,
                  primary: primaryColor,
                  secondary: secondaryColor,
                }
              )
              .then((response) => {
                return response;
              });
            this.ColoredLayout = data;

            this.svgStrings.push(this.ColoredLayout["response"][0]["svg"]);
            this.fetchLayout = false;
            console.log("Inside");
          }
          let image = this.ColoredLayout["response"][0]["image"];

          let text = this.ColoredLayout["response"][0]["text"];
          svgString = this.svgStrings[i];

          canvas = new fabric.Canvas(`my-previewcanvaslink${i}`, {
            width: 1080,
            height: 1080,
            preserveObjectStacking: true,
          });
          if (
            this.ParagraphFont != post.fontFamily[1] ||
            this.primaryFont != post.fontFamily[0]
          ) {
            this.ParagraphFont = post.fontFamily[1];
            this.primaryFont = post.fontFamily[0];
            // await this.fontLoad();
          }
          console.log("ola");
          let scalex = zoomWidth / originalWidth;
          let scaley = zoomHeight / originalHeight;
          let scaleratio = Math.min(scalex, scaley);
          const zoomX = zoomWidth / originalWidth;
          const zoomY = zoomHeight / originalHeight;

          const zoomWindowWidth = window.innerWidth * zoomX;
          const zoomWindowHeight = window.innerHeight * zoomY;
          console.log(zoomWindowWidth, zoomWindowHeight, "dimension");
          let zoomFactor = Math.min(
            zoomWindowWidth / originalWidth,
            zoomWindowHeight / originalHeight
          );

          canvas.setZoom(zoomFactor);
          let Coords = this.converter(
            image,
            text,
            originalWidth,
            originalHeight,
            canvasWidth,
            canvasHeight
          );
          let imageCoords = Coords[0];
          let textCoords = Coords[1];
          const text1 = new fabric.Text(post.text[0], {
            left:
              post.Coords_text[0] != null
                ? post.Coords_text[0]["x"]
                : textCoords[0][0],

            top:
              post.Coords_text[0] != null
                ? post.Coords_text[0]["y"]
                : textCoords[0][1],

            id: "text1",
            // fontFamily:  post.fontFamily[1],
            fill: text1Color,
            fontFamily: post.fontFamily[0],
            fontSize:
              post.Coords_text[0] != null
                ? post.Coords_text[0]["size"]
                : text[0]["size"],
          });
          const text2 = new fabric.Text(post.text[1], {
            left:
              post.Coords_text[1] != null
                ? post.Coords_text[1]["x"]
                : textCoords[1][0],

            top:
              post.Coords_text[1] != null
                ? post.Coords_text[1]["y"]
                : textCoords[1][1],

            id: "text2",
            // fontFamily:  post.fontFamily[1],
            fill: text2Color,
            fontFamily: post.fontFamily[1],
            fontSize:
              post.Coords_text[1] != null
                ? post.Coords_text[1]["size"]
                : text[1]["size"],
          });
          const text3 = new fabric.Text(post.text[2], {
            left:
              post.Coords_text[2] != null
                ? post.Coords_text[2]["x"]
                : textCoords[2][0],

            top:
              post.Coords_text[2] != null
                ? post.Coords_text[2]["y"]
                : textCoords[2][1],

            id: "text3",
            // fontFamily:  post.fontFamily[1],
            fill: text3Color,
            fontFamily: post.fontFamily[1],
            fontSize:
              post.Coords_text[2] != null
                ? post.Coords_text[2]["size"]
                : text[2]["size"],
          });
          const text4 = new fabric.Text(post.text[3], {
            left:
              post.Coords_text[3] != null
                ? post.Coords_text[3]["x"]
                : textCoords[3][0],

            top:
              post.Coords_text[3] != null
                ? post.Coords_text[3]["y"]
                : textCoords[3][1],

            id: "text3",
            // fontFamily:  post.fontFamily[1],
            fill: text4Color,
            fontFamily: post.fontFamily[1],
            fontSize:
              post.Coords_text[3] != null
                ? post.Coords_text[3]["size"]
                : text[3]["size"],
          });
          let lockobj = {
            lockMovementX: true,
            lockMovementY: true,
            lockScalingX: true,
            lockScalingY: true,
            lockScalingY: true,
            lockRotation: true,
            selectable: false,
          };
          text1.set(lockobj);
          text2.set(lockobj);
          text3.set(lockobj);
          text4.set(lockobj);

          canvas.add(text1, text2, text3, text4);
          let imageWidthRelativeToFrame = image[1]["width"];
          let imageHeightRelativeToFrame = image[1]["height"];
          let scaleX = canvasWidth / originalWidth;
          let scaleY = canvasHeight / originalHeight;
          let imageWidthonCanvas = imageWidthRelativeToFrame * scaleX;
          let imageHeightonCanvas = imageHeightRelativeToFrame * scaleY;
          const imgelement1 = document.createElement("img");
          imgelement1.src = this.url + "/" + image_url;

          imgelement1.onload = () => {
            let fabricImg = new fabric.Image(imgelement1, {
              left:
                post.Coords_image[1] != null
                  ? post.Coords_image[1]["x"]
                  : imageCoords[1][0],
              top:
                post.Coords_image[1] != null
                  ? post.Coords_image[1]["y"]
                  : imageCoords[1][1],
              id: "Image1",
            });
            let w =
              post.Coords_image[1] != null
                ? post.Coords_image[1]["width"]
                : imageWidthonCanvas;
            let h =
              post.Coords_image[1] != null
                ? post.Coords_image[1]["height"]
                : imageHeightonCanvas;

            fabricImg.scaleToWidth(w);
            fabricImg.scaleToHeight(h);
            fabricImg.set(lockobj);
            canvas.add(text1, text2, text3, text4);
            canvas.add(fabricImg);
          };
          imageWidthRelativeToFrame = image[0]["width"];
          imageHeightRelativeToFrame = image[0]["height"];
          scaleX = canvasWidth / originalWidth;
          scaleY = canvasHeight / originalHeight;
          imageWidthonCanvas = imageWidthRelativeToFrame * scaleX;
          imageHeightonCanvas = imageHeightRelativeToFrame * scaleY;
          const imgelement0 = document.createElement("img");
          imgelement0.src = this.url + "/" + logo_url;
          imgelement0.onload = () => {
            let fabricImg = new fabric.Image(imgelement0, {
              left:
                post.Coords_image[0] != null
                  ? post.Coords_image[0]["x"]
                  : imageCoords[0][0],
              top:
                post.Coords_image[0] != null
                  ? post.Coords_image[0]["y"]
                  : imageCoords[0][1],
              id: "Image2",
            });
            let w =
              post.Coords_image[0] != null
                ? post.Coords_image[0]["width"]
                : imageWidthonCanvas;
            let h =
              post.Coords_image[0] != null
                ? post.Coords_image[0]["height"]
                : imageHeightonCanvas;
            fabricImg.scaleToWidth(w);
            fabricImg.scaleToHeight(h);
            fabricImg.set(lockobj);
            canvas.add(text1, text2, text3, text4);
            canvas.add(fabricImg);
          };

          fabric.loadSVGFromString(svgString, (objects, options) => {
            const svg = fabric.util.groupSVGElements(objects, options);
            svg.set({
              left: 0,
              top: 0,

              lockMovementX: true,
              lockMovementY: true,
              lockScalingX: true,
              lockScalingY: true,
              lockScalingY: true,
              lockRotation: true,
              selectable: false,
            });
            // svg.scale(Math.min(200 / svg.width, 200 / svg.height));

            // svg.scale(scaleratio);
            console.log("svgString", svg);
            canvas.add(svg);
            canvas.sendToBack(svg);
          });

          canvas.renderAll();
        }
        if (i <= this.Posts.length - 1) {
          this.fetchLayout = true;
        }
      }
      this.PreviousLayoutIds = this.NewLayoutIds;
      this.isSvgupdating = false;
    },

    shareImage(url) {
      url = process.env.VUE_APP_IMAGE_URL + "/" + url.link;
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "posts.jpg";

          downloadLink.click();
          URL.revokeObjectURL(downloadLink.href);
          downloadLink.remove();
        })
        .catch((error) => {
          console.error("Error downlaoding file:", error);
        });
    },
    updatePopupDetails(index) {
      this.$emit("Platformname", "LinkedIn");
      this.$emit("isShowUpdate", index);
    },

    setLayout(index) {
      console.log();
      // for (let index = 0; index < this.eventsCard.length; index++) {
      if (index < 9) {
        return this.layoutSelected.layout.includes(index);
      } else {
        const layout = index % 9;
        return this.layoutSelected.layout.includes(layout);
      }
      // }
    },

    updateDetails() {
      this.isShowContentEdit = false;
    },
  },
};
</script>
